import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Button } from './ui/button';
import { AlertTriangle, CreditCard, Lock } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const ExpiredSubscriptionModal = ({ subscriptionStatus, onClose }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleRenew = () => {
    navigate('/pricing');
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-red-300 shadow-2xl">
        <CardHeader className="bg-red-50 border-b border-red-200">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-red-100 rounded-full">
              <Lock className="h-6 w-6 text-red-600" />
            </div>
            <div>
              <CardTitle className="text-red-900">{t('subscriptionExpired')}</CardTitle>
              <CardDescription className="text-red-700">
                {t('renewToAccessDashboard')}
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-6 space-y-4">
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="h-5 w-5 text-orange-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-orange-900 mb-1">
                  {t('accessLocked')}
                </p>
                <p className="text-sm text-orange-700">
                  {t('subscriptionExpiredMessage')}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <CreditCard className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-blue-900 mb-1">
                  {t('yourDataIsSafe')}
                </p>
                <p className="text-sm text-blue-700">
                  {t('dataPreservedMessage')}
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-2 pt-2">
            <Button 
              onClick={handleRenew}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-6 text-lg shadow-lg"
            >
              <CreditCard className="h-5 w-5 mr-2" />
              {t('renewSubscription')}
            </Button>
            
            <p className="text-xs text-center text-gray-500 pt-2">
              {t('chooseMonthlyOrYearly')}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExpiredSubscriptionModal;
